import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ActionErrorAlertComponent,
  ActionSuccessAlertComponent,
  AlertComponent,
  AlertCustomComponent,
  AlertHostComponent,
  AlertLoadingComponent,
  AlertUndoComponent,
  TryAgainActionErrorAlertComponent,
} from './components';
import { AlertService, AlertStoreService, HostHandlerService } from './services';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { DynamicIoModule } from 'ng-dynamic-component';
import { LoadersModule } from '@anecdotes/design-system/loaders';

@NgModule({
  imports: [CommonModule, TranslateModule, OverlayModule, ButtonsModule, DynamicIoModule, LoadersModule],
  declarations: [
    AlertComponent,
    AlertCustomComponent,
    AlertHostComponent,
    ActionErrorAlertComponent,
    AlertUndoComponent,
    TryAgainActionErrorAlertComponent,
    AlertLoadingComponent,
    ActionSuccessAlertComponent,
  ],
  exports: [AlertComponent, ActionErrorAlertComponent],
})
export class AlertModule {
  constructor(private hostHandler: HostHandlerService) {
    this.hostHandler.init();
  }

  static forRoot(): ModuleWithProviders<AlertModule> {
    return {
      ngModule: AlertModule,
      providers: [AlertService, AlertStoreService, HostHandlerService],
    };
  }
}
